"use client";

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@instadeepai/fontawesome-pro-regular";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import { Card, Progress } from "@shared/ui";

export function ForgeFormCompletion() {
    return (
        <Card className="flex flex-col gap-6 p-8 border rounded-xl w-[560px] h-[588px] bg-white shadow-[0px_0px_40px_0px_rgba(100,103,198,0.30)]">
            <div className="flex-grow flex flex-col justify-center items-center text-center">
                <div className="mb-6">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <FontAwesomeIcon icon={faCheck as IconProp} className="text-green-600" size="lg" />
                    </div>
                    <h1 className="font-semibold text-[#121926] text-[32px] mb-2">
                        Thank you!
                    </h1>
                    <p className="text-[#576272] text-[18px]">
                        Your responses have been submitted successfully. We'll review your requirements and get back to you soon.
                    </p>
                </div>
            </div>
            <div className="flex gap-4 items-center">
                <Progress value={100} variant="linear" className="w-full h-2" />
                <p className="text-[#576272] text-[14px] font-medium whitespace-nowrap">
                    Complete
                </p>
            </div>
        </Card>
    );
} 